import { API } from "@/lib/api";

// Report client-side runtime errors to the backend for debugging.
// Uses sendBeacon when possible so it survives even if the page is crashing.
export function reportClientError(kind, payload) {
  try {
    const body = JSON.stringify({
      kind,
      ...payload,
      url: window.location.href,
      ua: navigator.userAgent,
      ts: new Date().toISOString(),
    });
    const url = `${API}/client-log`;
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
    } else {
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    /* never let logging throw */
  }
}

export function installGlobalErrorReporting() {
  window.addEventListener("error", (e) => {
    reportClientError("window.error", {
      message: e?.message,
      stack: e?.error?.stack,
      filename: e?.filename,
      lineno: e?.lineno,
      colno: e?.colno,
    });
  });
  window.addEventListener("unhandledrejection", (e) => {
    const r = e?.reason;
    reportClientError("unhandledrejection", {
      message: (r && (r.message || String(r))) || "unknown",
      stack: r && r.stack,
    });
  });
}
